"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Input = _interopRequireDefault(require("../Input"));

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

var _createStyled = require("../../utils/createStyled");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var SearchInput = function SearchInput(_ref) {
  var className = _ref.className,
      attribute = _ref.attribute,
      theme = _ref.theme,
      style = _ref.style,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      elementRef = _ref.elementRef,
      onChange = _ref.onChange,
      showClear = _ref.showClear,
      value = _ref.value,
      Component = _ref.component,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "attribute", "theme", "style", "onFocus", "onBlur", "elementRef", "onChange", "showClear", "value", "component"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1],
      computedTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [theme, style]),
      styles = (0, _react.useMemo)(function () {
    return (0, _style["default"])(computedTheme, {
      focus: focus
    });
  }, [computedTheme, focus]),
      handleFocus = (0, _react.useCallback)(function (e) {
    setFocus(true);

    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  }, [onFocus]),
      handleBlur = (0, _react.useCallback)(function (e) {
    setFocus(false);

    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  }, [onBlur]),
      input = (0, _react.useRef)(null),
      handleRef = (0, _react.useCallback)(function (el) {
    if (typeof elementRef === 'function') {
      elementRef(el);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = el;
    }

    input.current = el;
  }, [elementRef]),
      clear = (0, _react.useCallback)(function () {
    if (typeof onChange === 'function' && input.current) {
      input.current.value = '';
      onChange((0, _syntheticEvent["default"])(input.current));
    }
  }, [onChange, input === null || input === void 0 ? void 0 : input.current]),
      SearchIcon = computedTheme.searchIcon,
      ClearIcon = computedTheme.clearIcon,
      styleMemo = (0, _react.useMemo)(function () {
    return style ? (0, _deepmerge["default"])(styles.input, style) : styles.input;
  }, [style]);

  return _react["default"].createElement("div", {
    className: className
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.search
  }, _react["default"].createElement(SearchIcon, null)), _react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, rest, {
    attribute: attribute,
    style: styleMemo,
    "data-qa-node": "search-input__field",
    onFocus: handleFocus,
    onBlur: handleBlur,
    elementRef: handleRef,
    value: value,
    onChange: onChange
  })), showClear && !!value ? _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.clear,
    "data-qa-node": "".concat(attribute, "-clear"),
    onClick: clear
  }, _react["default"].createElement(ClearIcon, null)) : null));
};

SearchInput.defaultProps = {
  showClear: true,
  component: _Input["default"]
};
SearchInput.propTypes = {
  showClear: _propTypes["default"].bool,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  value: _propTypes["default"].any,
  className: _propTypes["default"].string,
  attribute: _propTypes["default"].string,
  style: _propTypes["default"].object,
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    palette: _propTypes["default"].object,

    /**
     * @default searchIcon
     */
    searchIcon: _propTypes["default"].func,

    /**
     * @default clearIcon
     */
    clearIcon: _propTypes["default"].func,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    searchIconWidth: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    searchIconHeight: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    clearIconHeight: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    clearIconWidth: _propTypes["default"].string
  }),
  onChange: _propTypes["default"].func
};
var _default = SearchInput;
exports["default"] = _default;